"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledVisuallyHidden = void 0;
var _VisuallyHidden = require("./VisuallyHidden");
// TODO: in v9, move styled() from VisuallyHidden.jsx to here
var StyledVisuallyHidden = _VisuallyHidden.VisuallyHidden;
exports.StyledVisuallyHidden = StyledVisuallyHidden;